/**
 * Storm Tracker: Hurricane & Tornado Alerts USA — severe-weather notifier
 *
 * Its single web-accessible-resource entry lists eleven concrete SVG assets, matched
 * to `<all_urls>` with no `use_dynamic_url`, so each is fetchable from any page at a
 * fixed URL. The vendor-named `assets/notification-logo.svg` is served only when the
 * extension is installed.
 *
 * SVGs load through `probeImage` with no CORS grant, so the signals survive a
 * restrictive page CSP.
 *
 * Manifest verified against version 1.7.2.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bnkaaocadlimipknmjoebcfnjfffdnif';

export const stormTracker: ExtensionDefinition = {
  id: ID,
  name: 'Storm Tracker: Hurricane & Tornado Alerts USA',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 10_000,
  notes:
    'Eleven static SVG WAR on every origin with no dynamic URL. The notification-logo ' +
    'SVG is conclusive and loads via <img> without a CORS grant.',
  signals: [
    {
      id: 'war-notification-logo-svg',
      kind: 'web-accessible-resource',
      description:
        'Load assets/notification-logo.svg via <img> — the notification branding, ' +
        'exposed to every origin and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'assets/notification-logo.svg'),
    },
    {
      id: 'war-warning-icon-svg',
      kind: 'web-accessible-resource',
      description:
        'Load assets/warning-icon.svg via <img> — a second exposed asset, ' +
        'corroborating the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/warning-icon.svg'),
    },
    {
      id: 'war-wind-direction-svg',
      kind: 'web-accessible-resource',
      description:
        'Load assets/wind-direction.svg via <img> — a third exposed asset, ' +
        'independent of the other two paths.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/wind-direction.svg'),
    },
  ],
};
